import devConfig from './env/dev.json';
import qaConfig from './env/qa.json';
import ptConfig from './env/pre-prod.json';
import psConfig from './env/ps.json';
import prodConfig from './env/prod.json';
import selectedConfig from './env/selected.json';

const host = window.location.origin;
const getConfig = () => {
  try {
    if (host.includes('merchant-web-dev.alp-robinhood.com') || host.includes('localhost:3000')) {
      return devConfig;
    } else if (host.includes('merchant-web-qa.alp-robinhood.com')) {
      return qaConfig;
    } else if (host.includes('merchant-web-pt.alp-robinhood.com')) {
      return ptConfig;
    } else if (host.includes('merchant-web-ps.alp-robinhood.com')) {
      return psConfig;
    } else if (host.includes('merchantportal.robinhood.in.th')) {
      return prodConfig;
    } else {
      return selectedConfig;
    }
  } catch (e) {
    // Check IE 11
    const ua = navigator.userAgent.toLowerCase();
    const trident = ua.indexOf('trident/');
    const rv = ua.indexOf('rv:');
    if (trident > 0 && rv > 0) {
      const ieVersion = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      if (ieVersion === 11) {
        window.location.href = 'browserNotSupported.html';
      }
    } else {
      // Check IE 6-10
      const msie = ua.indexOf('msie ');
      if (msie > 0) {
        const ieVersion = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        if (ieVersion <= 10) {
          window.location.href = 'browserNotSupported.html';
        }
      }
    }
  }
};

export const envConfig = Object.assign({}, getConfig()) as IEnvironmentConfig;

interface IEnvironmentConfig {
  environment: 'dev' | 'qa' | 'pre-prod' | 'prod' | 'ps';
  awsCognitoRegion: string;
  awsCognitoUserPoolId: string;
  awsCognitoUserPoolWebClientId: string;
  hostname: string;
  timeOutIdleTimer: number;
  googleApiKey: string;
}
